import React, { Component } from "react";

import { css } from "glamor";
import { Form, Input, Button } from "antd";

const styles = {
    button: css({
        marginRight: ".75em",
    }),
};

export class CommentForm extends Component {
    state = {
        comment: "",
    };

    handleCommentSubmit = e => {
        e.preventDefault();

        if (this.props.onSubmit) {
            this.props.onSubmit(this.state.comment);
            this.setState({ comment: "" });
        }
    };

    handleCommentChange = e => {
        this.setState({ comment: e.target.value });
    };

    isButtonDisabled = () => {
        return this.props.isLoading || this.state.comment.length === 0;
    };

    handleCancel = e => {
        e.preventDefault();
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    };

    render() {
        return (
            <Form onSubmit={this.handleCommentSubmit}>
                <Form.Item>
                    <Input.TextArea
                        onChange={this.handleCommentChange}
                        rows={3}
                        value={this.state.comment}
                    />
                </Form.Item>
                <Form.Item>
                    <Button
                        className={`${styles.button}`}
                        disabled={this.isButtonDisabled()}
                        htmlType="submit"
                        loading={this.props.isLoading}
                        type="primary"
                    >
                        {this.props.isReplying ? "Add Reply" : "Add Comment"}
                    </Button>

                    {this.props.isReplying && (
                        <Button
                            className={`${styles.button}`}
                            icon="close"
                            onClick={this.handleCancel}
                        >
                            Cancel
                        </Button>
                    )}
                </Form.Item>
            </Form>
        );
    }
}
